import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { TaskModel } from '@/components/tasks-kanban/models';
import { PropType } from 'vue';
import { ConnectIcon } from 'tir-style-system/icons/outline';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-expand',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
},
  emits: ["current", "other"],
  setup(__props, { emit }) {


/**События */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "task-card-expand",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"])),
    onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent","stop"]))
  }, [
    (__props.task.CurrentQueueSubtaskCount)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "task-card-expand_item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('current')))
        }, [
          _createVNode(_unref(ConnectIcon)),
          _createTextVNode(" " + _toDisplayString(__props.task.CurrentQueueSubtaskCount), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.task.OtherQueueSubtaskCount)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "task-card-expand_item other",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('other')))
        }, [
          _createVNode(_unref(ConnectIcon)),
          _createTextVNode(" " + _toDisplayString(__props.task.OtherQueueSubtaskCount), 1)
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})